import { useCurrentUser } from 'hooks/api/use-current-user';
import { useImpersonation } from 'hooks/use-impersonation';
import { ROLES } from 'constants/roles';

const JOB_TITLE_EDITOR_AUTHORITIES: string[] = [
  ROLES.FD_PRINCIPAL,
  ROLES.FD_CLIENT_SERVICE,
];

const JOB_TITLE_EDITABLE_TARGET_AUTHORITIES: string[] = [
  ROLES.USER,
  ROLES.INTERNAL_USER,
];

interface UseCanOnlyEditJobTitleArgs {
  user?: { id?: string | number; authority?: string } | null;
  isCurrentUserProfile?: boolean;
}

export const useCanOnlyEditJobTitle = ({
  user,
  isCurrentUserProfile,
}: UseCanOnlyEditJobTitleArgs): boolean => {
  const { data: currentUser } = useCurrentUser();
  const impersonation = useImpersonation();

  if (
    !user ||
    user.id == null ||
    isCurrentUserProfile ||
    impersonation.isImpersonating()
  ) {
    return false;
  }

  return (
    JOB_TITLE_EDITOR_AUTHORITIES.includes(currentUser?.authority ?? '') &&
    String(currentUser?.id) !== String(user.id) &&
    JOB_TITLE_EDITABLE_TARGET_AUTHORITIES.includes(user.authority ?? '')
  );
};
